import type { ReactNode } from 'react';
import { Dialog } from './dialog';
import { MutationError } from './kit';

/**
 * Confirmation step before a consequential change (revoke, disable, delete, turn off protection).
 * For destructive actions (`danger`) focus starts on Cancel, so Enter never confirms by accident.
 */
export function ConfirmDialog({ title, children, confirmLabel, danger = false, busy = false, error, onConfirm, onClose }: {
  title: ReactNode;
  children: ReactNode;
  confirmLabel: string;
  danger?: boolean;
  busy?: boolean;
  error?: unknown;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Dialog title={title} onClose={onClose} busy={busy}
      footer={<>
        <button type="button" className="btn" onClick={onClose} disabled={busy} data-autofocus={danger ? true : undefined}>Cancel</button>
        <button type="button" className={`btn primary${danger ? ' danger' : ''}`} onClick={onConfirm} disabled={busy} data-autofocus={danger ? undefined : true}>{busy ? 'Working…' : confirmLabel}</button>
      </>}>
      {children}
      <MutationError error={error} />
    </Dialog>
  );
}
